import React from 'react';
import styled from 'astroturf/react';
import { VerticalSpacer } from './VerticalSpacer';
import ErrorIcon from 'js/design_system/icons/error.svg';
import { Body } from 'js/design_system/Body';
import _ErrorDiv from "ModalError-ErrorDiv.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/login_modal/components/ModalError.tsx?styleId=ErrorDiv";
import _IconDiv from "ModalError-IconDiv.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/login_modal/components/ModalError.tsx?styleId=IconDiv";


const ErrorDiv = /*#__PURE__*/styled(Body, null, {
  displayName: "ErrorDiv",
  styles: _ErrorDiv,
  attrs: props => ({
    ...props,
    size: 'sm'
  })
});

const IconDiv = /*#__PURE__*/styled("div", null, {
  displayName: "IconDiv",
  styles: _IconDiv
});

type Props = {
  show?: boolean;
  errorMessage?: string;
};

export const ModalError: React.FC<Props> = ({ show = true, errorMessage }) => {
  return show ? (
    <>
      <VerticalSpacer height={32} />
      <ErrorDiv>
        <IconDiv>
          <ErrorIcon />
        </IconDiv>
        {errorMessage ?? 'Something went wrong. Please try again.'}
      </ErrorDiv>
    </>
  ) : (
    <></>
  );
};
